import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Grid, TextField, Button, CircularProgress, Card, CardHeader, CardContent, CardActions, Divider } from '@material-ui/core'
import { Breadcrumb } from 'components'
import { connect } from 'react-redux'
import { CategoriesActions } from 'redux/actions';
import { Transition } from 'react-transition-group';
import { useHistory, useRouteMatch } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
    },
  },
  header: {
    background: '#f3f3f3b3',
    padding: '10px 16px',
  },
  content: {
    marginTop: theme.spacing(2)
  },
  inputRoot: {
    '& .MuiInput-input': {
      height: '28px',
      lineHeight: '28px',
      fontWeight: 500,
    },
},
}));

const CategoriesForm = props => {
    const {
        getCategory,
        saveCategory,
        setFormPropertyValue,
        category,
        reset,
    } = props
    
    const theme = useTheme();
    const classes = useStyles();
    const history = useHistory();
    const match = useRouteMatch()
    
    const transitionStyles = {
        entered:  { transform: 'translateY(0) scale(1)' },
    };

    useEffect(() => {
        if (match.params.id) {
            getCategory(match.params.id)
        }

        return () => {
            reset('CATEGORIES_CATEGORY_RESET')
        }
    }, [getCategory, reset, match.params.id])

    useEffect(() => {
        if (category.actions.save.success) {
            history.goBack()
        }
    }, [category.actions.save.success, history])
  
    return (
        <div className={classes.root}>
            <Breadcrumb
                path={[
                    {
                        name: 'Categorías'
                    },
                    {
                        name: match.params.id ? 'Editar' : 'Nuevo'
                    }
                ]}
            />

            {((match.params.id && category.loading) || category.actions.save.loading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginTop="30px"
                >
                    <CircularProgress />
                </Box>
            ) : (
                <Transition in={true} appear={true} timeout={0}>
                    {state => (
                        <Box paddingBottom={3}>
                            <Card style={{ transform: 'translateY(15px) scale(0.99)', transition: theme.transitions.create(['transform'], { duration: 150, easing: theme.transitions.easing.sharp }), ...transitionStyles[state] }}>
                                <CardHeader
                                    className={classes.header}
                                    title="Categoría"
                                    subheader={match.params.id ? "Editar categoría" : "Crear nueva categoría"}
                                />

                                <Divider />

                                <CardContent className={classes.content}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                classes={{
                                                    root: classes.inputRoot
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth
                                                label="Nombre"
                                                value={category.data.name}
                                                onChange={(e) => {
                                                    setFormPropertyValue('name', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>

                                <Divider />

                                <CardActions
                                    style={{
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            history.goBack()
                                        }}
                                    >
                                        VOLVER
                                    </Button>
                                    
                                    <Button
                                        disabled={!category.data.name}
                                        color="primary"
                                        variant="contained"
                                        onClick={() => {
                                            if (match.params.id) {
                                                return saveCategory(category.data.id, {
                                                    nombre: category.data.name,
                                                })
                                            }

                                            saveCategory(null, {
                                                nombre: category.data.name,
                                            })
                                        }}
                                    >
                                        GUARDAR
                                    </Button>
                                </CardActions>
                            </Card>
                        </Box>
                    )}
                </Transition>
            ))}
        </div>
    );
};

const mapStateToProps = state => ({
    category: state.categories.category,
})

const mapDispatchToProps = dispatch => ({
    getCategory: (id) => dispatch(CategoriesActions.getCategory(id)),
    saveCategory: (id, data, patch) => dispatch(CategoriesActions.saveCategory(id, data, patch)),
    setFormPropertyValue: (property, value) => dispatch(CategoriesActions.setFormPropertyValue(property, value)),
    reset: (type) => dispatch(CategoriesActions.reset(type))
})

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesForm);
